import styled from 'styled-components'
import { colors, breakpoints } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 24px;
  background: white;
`

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
`

const Subtitle = styled.div`
  color: ${colors.grey40};
  font-size: 14px;
`

const BoldText = styled.div`
  font-weight: 700;
  font-size: 14px;
`

const Link = styled.a`
  color: ${colors.link};
  cursor: pointer;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

export { Wrapper, Title, Subtitle, BoldText, Link, Row, Col }
